module.exports = __webpack_public_path__ + "static/media/product11.17a43218.jpg";